<template>
    
    <div class="dialog-cover">
        
        <div class="card-dialog-main">

            <img :src="selectedImage.src" class="scenery-pic"  />

            <div class="scenery-name"> 

                <img :src="images.decorationLeft" class="scenery-name-pic"  />
    
                {{ selectedImage.title }} 

                <img :src="images.decorationRight"  class="scenery-name-pic" />
            </div>

            <div class="scenery-detail">
                {{ selectedImage.detail }}
            </div>
        </div>

        <div class="card-dialog-btn-group">
            
            <img 
                :src="images.dialogResetBtn" 
                style="margin-right: 1rem"
                class="btn"
                @click="reselect"
            />

            <img 
                :src="images.dialogStartBtn" 
                class="btn"
                @click="startGame"
            />
        </div>
    </div>
</template>

<script>

    import { toRefs, reactive, getCurrentInstance } from "vue";

    import dialogResetBtn from "@/assets/card/dialog-reset-btn.png";
    import dialogStartBtn from "@/assets/card/dialog-start-btn.png";
    import decorationLeft from "@/assets/card/decoration-left.png";
    import decorationRight from "@/assets/card/decoration-right.png";

    export default {
        name: "CardDialog",
        props: {
            selectedImage: {
                type: Object
            }
        },
        setup() {

            const _this = getCurrentInstance().appContext.config.globalProperties;

            const { ENUM, EVENT } = _this.$constants;

            const { PUZZLE_SELECT_OPERATION } = EVENT;

            const state = reactive({
                images: {
                    dialogResetBtn: dialogResetBtn,
                    dialogStartBtn: dialogStartBtn,
                    decorationLeft,
                    decorationRight
                }
            });

            const reselect = () => {

                _this.$bus.$emit(PUZZLE_SELECT_OPERATION, {
                    type: ENUM.PUZZLE_SELECT_OPERATION.RE_SELECT
                });
            };

            const startGame = () => {

                _this.$bus.$emit(PUZZLE_SELECT_OPERATION, {
                    type: ENUM.PUZZLE_SELECT_OPERATION.START_GAME
                });
            }

            return {
                ...toRefs(state),
                reselect,
                startGame
            };
        }
    }
</script>

<style lang="scss" scoped>

    .card-dialog-main::before {
        
        content: "";
        width: 0;
        height: 100%;
        display: inline-block;
        vertical-align: middle;
    }

    .card-dialog-main {

        background-image: url(../assets/card/dialog-bg.png);
        background-position: 50% 50%;
        background-size: cover;
        position: fixed;
        top: 45%;
        left: 50%;
        transform: translate(-50%, -50%);
        height: calc(848px / 2.5);
        width: calc(1125px / 2.5);

        .scenery-pic {
            width: 8rem;
            height: auto;
            position: fixed;
            left: 50%;
            transform: translate(-50%, -50%);
            top: 12%;
            border-radius: 10px;
            border: 3px solid #FCF4E4;
        }

        .scenery-name {
            color: #cb9464;
            font-weight: bold;
            position: fixed;
            top: 40%;
            font-size: 1.1rem;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            width: 100%;
        }

        .scenery-name-pic {
            height: 0.9rem;
            width: auto;
        }

        .scenery-name-pic:nth-of-type(1) {
            margin-right: 0.5rem;
        }

        .scenery-name-pic:nth-of-type(2) {
            margin-left: 0.5rem;
        }

        .scenery-detail {
            position: relative;
            bottom: 48%;
            color: #AD7F58;
            font-size: 13px;
            width: 62vw;
            left: calc((100% - 62vw) / 2);
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            flex-wrap: wrap;
            line-height: 1.3rem;
            letter-spacing: 0.1rem;
            text-indent: 1.8rem;
        }
    }

    .card-dialog-btn-group {

        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        position: fixed;
        left: 0;
        right: 0;
        
        img {
            height: 40px;
            width: auto;
        }
    }

    @media screen and (min-height: 800px) {
        
        .card-dialog-btn-group {
            top: calc(45% + 300px - 15%);
        }
    }

    @media screen and (max-height: 800px) {
        
        .card-dialog-btn-group {
            top: calc(45% + 300px - 20%);
        }
    }
</style>